/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PatientVolunteer from './patient-volunteer';
import PatientVolunteerDetail from './patient-volunteer-detail';
import PatientVolunteerUpdate from './patient-volunteer-update';
import PatientVolunteerDeleteDialog from './patient-volunteer-delete-dialog';

const PatientVolunteerRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PatientVolunteer />} />
    <Route path="new" element={<PatientVolunteerUpdate />} />
    <Route path=":id">
      <Route index element={<PatientVolunteerDetail />} />
      <Route path="edit" element={<PatientVolunteerUpdate />} />
      <Route path="delete" element={<PatientVolunteerDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PatientVolunteerRoutes;
